import { useCallback } from 'react';

import { useAnalytics } from '@bonusly/who-am-i';

import { CelebrationType } from '../types';

export type CelebrationEventProps = {
	celebrationType: CelebrationType;
};

export enum EventName {
	UserPopoverCelebrationLinkClick = 'User Popover Celebration Link Click',
}

export const useTrackCelebrations = () => {
	const { track } = useAnalytics();

	const trackUserPopoverCelebrationLinkClick = useCallback(
		(eventProps: CelebrationEventProps) => {
			track(EventName.UserPopoverCelebrationLinkClick, {
				...eventProps,
			});
		},
		[track]
	);

	return {
		trackUserPopoverCelebrationLinkClick,
	};
};
